function cityNavigation() {
  const navigation = document.querySelector('.sf-navigation-list');
  if (!navigation) return;
  const buttons = [...navigation.querySelectorAll('button[data-nav]')];
  const sections = [...document.querySelectorAll('.section--sf-city')];
  function choose(button) {
    const target = sections.find(section => section.querySelector('.sf-city')?.dataset.nav === button.dataset.nav);
    if (!target) return;
    buttons.forEach(item => { item.classList.toggle('active', item === button); item.setAttribute('aria-pressed', String(item === button)); });
    sections.forEach(section => { section.style.display = section === target ? 'block' : 'none'; });
  }
  buttons.forEach(button => {
    if (!button.dataset.bound) { button.addEventListener('click', () => choose(button)); button.dataset.bound = 'true'; }
  });
  const initial = buttons.find(button => button.classList.contains('active')) || buttons[0];
  if (initial) choose(initial);
  const weekday = new Intl.DateTimeFormat('en-GB', { timeZone:'Europe/Amsterdam', weekday:'short' }).format(new Date());
  const day = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'].indexOf(weekday);
  document.querySelectorAll('.sf-city-item').forEach(item => {
    const time = item.querySelectorAll('.sf-city-schedule li')[day]?.querySelector('.time')?.textContent?.trim();
    const label = item.querySelector('.sf-city-schedule-today span');
    if (time && label) label.textContent = time;
  });
}
function citySelected(id) {
  const section = document.getElementById('shopify-section-' + id);
  const city = section?.querySelector('.sf-city')?.dataset.nav;
  const button = [...document.querySelectorAll('.sf-navigation-list button[data-nav]')].find(item => item.dataset.nav === city);
  if (button) button.click();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cityNavigation);
else cityNavigation();
